const formatTransactionNumber = (transactionNumber = "", prefix = "#") =>
  `${prefix}${[
    transactionNumber.slice(0, 3),
    transactionNumber.slice(3, 6),
    transactionNumber.slice(6),
  ]
    .filter(Boolean)
    .join(" ")}`;

export default formatTransactionNumber;
